import _ from 'lodash';
import { createSelector } from 'reselect';

import { createMap } from 'Common/Helpers/format';
import { makeOptionsData } from 'Common/FormHelper';

const root = (state) => _.get(state, 'CommonState.sites');

export const getSitesResponse = (state) => _.get(root(state), 'info');

export const getSites = createSelector(getSitesResponse, (sitesResponse) => {
  return _.get(sitesResponse, 'Data', []);
});

export const getSitesMap = createSelector(getSites, (sites) => {
  return createMap(sites);
});

export const getSiteOptions = createSelector(getSites, (sites) => {
  return makeOptionsData(sites, {
    keyKey: 'Id',
    valueKey: 'Id',
    textKeys: ['Id', 'Description'],
  });
});

export const getSitesLoading = (state) => _.get(root(state), 'loading', false);

export const getSiteIds = createSelector(getSites, (sites) => {
  const siteIds = sites.map((s) => s.Id);

  return siteIds;
});

export const getAlternateProvisionTypeId = (state, siteId) => {
  const sitesMap = getSitesMap(state);

  return _.get(sitesMap, [siteId, 'AlternateProvisionTypeId']);
};



// WEBPACK FOOTER //
// ./src/state/sites/selectors.js